var _path, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMatching4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 34,
    viewBox: "0 0 30 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1056 0.447213C14.6686 0.165686 15.3314 0.165686 15.8944 0.447214L28.8944 6.94721C29.572 7.286 30 7.97852 30 8.73607V16.6667V24.5973C30 25.3548 29.572 26.0473 28.8944 26.3861L15.8944 32.8861C15.3314 33.1676 14.6686 33.1676 14.1056 32.8861L1.10557 26.3861C0.428004 26.0473 0 25.3548 0 24.5973V16.6667L0 8.73607C0 7.97852 0.428005 7.286 1.10557 6.94721L14.1056 0.447213Z",
    fill: "#BC72A7"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2170_7861",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 9,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 9.16666,
    width: 15,
    height: 15,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2170_7861)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.875 23.2292L11.6875 21.2292L9.4375 20.7292L9.65625 18.4167L8.125 16.6667L9.65625 14.9167L9.4375 12.6042L11.6875 12.1042L12.875 10.1042L15 11.0104L17.125 10.1042L18.3125 12.1042L20.5625 12.6042L20.3438 14.9167L21.875 16.6667L20.3438 18.4167L20.5625 20.7292L18.3125 21.2292L17.125 23.2292L15 22.3229L12.875 23.2292ZM13.4062 21.6354L15 20.9479L16.625 21.6354L17.5 20.1354L19.2188 19.7292L19.0625 17.9792L20.2188 16.6667L19.0625 15.3229L19.2188 13.5729L17.5 13.1979L16.5938 11.6979L15 12.3854L13.375 11.6979L12.5 13.1979L10.7812 13.5729L10.9375 15.3229L9.78125 16.6667L10.9375 17.9792L10.7812 19.7604L12.5 20.1354L13.4062 21.6354ZM14.3438 18.8854L17.875 15.3542L17 14.4479L14.3438 17.1042L13 15.7917L12.125 16.6667L14.3438 18.8854Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatching4);
export default __webpack_public_path__ + "static/media/matching4.1f479b7e.svg";
export { ForwardRef as ReactComponent };